import { c as o } from "./index766.mjs";
var t = o, a = String, i = function(r) {
  if (t(r) === "Symbol")
    throw new TypeError("Cannot convert a Symbol value to a string");
  return a(r);
};
export {
  i as t
};
